import {setScrollbarWidth, setViewport} from "./_layout.script";

setViewport();
setScrollbarWidth();
